import { Component, Input, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../data.service';
import { DOCUMENT } from "@angular/platform-browser"
@Component({
  selector: 'lc-productlist',
  templateUrl: './productlist.component.html',
  styleUrls: ['./productlist.component.scss']
})
export class ProductlistComponent implements OnInit {
  @Input() language: string = 'nl';
  @Input() type: string = 'products'; // or assets
  @Input() mode: string = 'authenticated'; // or anonymous
  @Input() super_orders: boolean = false; // allow orders for other users ....

  @Input() exclude_points_for_shipping: boolean = true; //redeem discount will not affect the free shipping earned

  @Input() filter: string;
  @Input() show_filters: boolean = true;
  @Input() page_type: string;
  @Input() listview: boolean = true; // start in list view
  @Input() qr_code: string;

  public translated_products: any;
  public filtered_products: any;
  public selected_product: any;
  public my_orders: any = [];
  public my_order_by_type: any = { 'ZOOM': [], 'SONICARE': [] };

  public translated_filters: any;
  public ext_filters: any;
  public active_filters: any[] = [];
  public keywords: string;
  public hidden_keywords: string;

  public filter_counts: any = {};
  public checkout_view: boolean = false;

  public order_shipping_cost: number = 0;
  public total_amount: number = 0;
  public total_products_amount: number = 0;

  public total_retail_value: number = 0;
  public total_discount: number = 0;
  public discount_from_points: number = 0;

  public total_products: number = 0;
  public specials_count: number = 0;
  public special_groups: any = {};

  public first_order_specials_count: number = 0;
  public filters_active: boolean = true;
  public cart_filter: boolean = false;
  public order_filter: any;
  public specials_filter: boolean = false;
  public loyaltyproduct_filter: boolean = false;
  public first_order_filter: boolean = false;
  public edit_invoice: boolean = false;
  public saving_invoice: boolean = false;
  public invoice_complete: boolean = true;
  public prev_address: string;
  public show_optin: boolean = false;

  private body: HTMLElement = this.document.body;
  private filterOriginalOffset: number;

  private predefined_list_nl = ["Tandenborstels", "Opzetborstels", "Opzetborstels (standaard)", "Opzetborstels (compact)", "Interdentaal", "Speciaal voor de praktijk & medewerker", "Bleken in de praktijk", "Thuis bleken", "Mondverzorging", "Marketingmaterialen", "Gepersonaliseerde middelen"];
  private predefined_list_en = ["In chair whitening", "In office whitening", "Take home whitening", "Accessories", "Utilities"];
  private predefined_list = this.predefined_list_nl.concat(this.predefined_list_en);

  public loading: boolean = true;
  public ordering: boolean = false;
  public show_redeem_explanation: boolean = false;

  public allow_first_order_specials: boolean = false;
  public confirm_order: boolean;
  public confirm_tos: boolean;

  public confirm_no_email: boolean;

  public redeem_points: number = 0;
  public max_redeem_points: number = 0;

  public show_details_for: string; // if this is a valid product ID it well open the details popup

  constructor(@Inject(DOCUMENT) private document: any,
    private route: ActivatedRoute,
    public dataService: DataService) {
  }

  ngOnChanges(changes) {
    if (!!changes.language && !!this.translated_products) {
      this.dataService.translate_list(this.translated_products);
      this.dataService.translate_list(this.filtered_products);
      this.dataService._translate_object(this.selected_product);
      this.update_filter();
      console.log(changes);
    }
  }

  ngOnInit() {

    this.listview = this.mode != 'anonymous';
    if (!this.show_filters) { this.listview = false; }
    this.route.params.subscribe(params => {
      if (!!params['pid']) {
        this.show_details_for = params['pid'];
      }
      this.get_remote_data();

    });

    if( !!this.dataService.optin_available && !!this.dataService.subuser_info && !this.dataService.subuser_info.optin_promos ){
      this.show_optin = true;
    }

    this.dataService.admin_storage.subscribe(event => {
      console.log(event.key);
      if(event.key == 'admin_products'){
        let updated_json = event.newValue;
        let updated_products = JSON.parse(updated_json);
        this.process_productlist(
          this.dataService.process_products(
            updated_products,
            this.allow_first_order_specials
          )
        );
        this.keywords = '';
        for( const p of updated_products){
          if(!!p.changed){
            this.keywords += ' ' + p.id;
          }
        }

      }
    });
  }

  order_conditions_complete(checkout = false) {
    let complete = false;
    if( this.total_products < 1) return false;
    
    //let cmpl = (super_orders && (!dataService.user_info || (dataService.send_order_email && !dataService.new_user_email) || (dataService.need_email_and_phone && !dataService.new_user_phone) || !dataService.new_user_lastname || !dataService.new_user_firstname))
    if( this.super_orders ){
      if( !this.dataService.user_info ) return false;
      if( !this.dataService.address_complete ) return false;
      if( !this.dataService.new_user_lastname ) return false;
      if( !this.dataService.new_user_firstname ) return false;
      if( this.dataService.need_email_and_phone && this.dataService.need_phone && !this.dataService.new_user_phone) return false;
      if( this.dataService.send_order_email && !this.dataService.new_user_email) return false;
      if( !checkout ) return true;
    }
    if( checkout && this.dataService.need_order_confirmation && !this.confirm_order ){
      return false;
    };
    if( checkout && !!this.dataService.subuser_info && this.dataService.INVOICE_BY_EMAIL && !this.dataService.subuser_info.optin_invoice){
      return false;
    };


    if (!!this.dataService.subuser_info && !!this.dataService.subuser_info.user_id) {
      if(!this.dataService.TOS_URL) {
        return true;
      } else {
        if(!checkout) {
          return true;
        } else {
          return this.confirm_tos;
        }
      }
    }

    if (this.dataService.send_order_email) {
      complete = this.confirm_order;
    } else {
      complete = this.confirm_order && this.confirm_no_email;
    }
    if (complete && this.dataService.need_phone && this.dataService.need_email_and_phone) {
      complete = !!this.dataService.new_user_phone;
    }
    return complete;
  }

  toggleListView(state: boolean) {
    this.listview = state;
  }

  format_price(cents){
    return cents.toString().slice(0,-2) + '.' + cents.toString().slice(-2);
  }

  process_productlist(data){
        let plist = data;
        if (this.mode == 'anonymous' && !this.super_orders) {
          plist = [];
          for (let p of data) {
            if (p.is_special) plist.push(p);
          }
        }
        this.translated_products = plist;
        // this.filtered_products = [...plist];
        let w_filters = [];
        let e_filters = [];

        this.filter_counts = {};
        this.specials_count = 0;
        this.first_order_specials_count = 0;
        for (let prod of data) {

          if(!!prod.stock && prod.stock < 0 && !this.dataService.allow_backorder){
            prod.max_units = -1;
            prod.note = this.dataService.translate.instant('NOTE: temporary out of stock');
            prod.status = "AVAILABLE"; // no need to handle SPECIALS 
          }
          prod.__max_units = prod.max_units;

          if (!!prod.is_special && !prod.max_points_allowed) this.specials_count++;
          if (prod.status == "FIRSTORDER_SPECIAL") this.first_order_specials_count++;

          if (!!prod.is_asset && prod.categorie) {
            let catkey = prod.categorie;
            if (!this.filter_counts[catkey]) {
              this.filter_counts[catkey] = 0;
              e_filters.push({ key: catkey, weight: 1, title: catkey, active: false, asset_allowed: true, asset_only: true });
            }
            this.filter_counts[catkey]++;
          }
          if (!!prod.filters && prod.filters.length > 0) {
            if (!Array.isArray(prod.filters)){
              prod.filters = [prod.filters]; // correct filter not formatted as a list
            }
            for (let filter_key of prod.filters) {
              if (!filter_key.startsWith('http')) {
                if (!this.filter_counts[filter_key] && !prod.is_hidden) {
                  this.filter_counts[filter_key] = 0;
                  let w = this.predefined_list.indexOf(filter_key);
                  if( this.language == 'es' && filter_key.startsWith('Sonicare') ) w = 100; // push whitening to to top
                  w_filters.push({ key: filter_key, weight: w, title: filter_key, active: false, asset_allowed: false, asset_only: false });
                }
                if( !prod.is_hidden ) {
                  this.filter_counts[filter_key]++;
                }
                if (!!prod.is_asset) {
                  for (let f of w_filters) {
                    if (f.key == filter_key) {
                      // f.asset_allowed = true;
                      f.asset_only = true;
                    }
                  }
                }
              }
            }
          }
        }
        // init the special groups
        this.special_groups = {};

        for (let product of this.translated_products) {
          if (!!product.special_group) {
            if( product.special_group == 'STICKY' ) continue;
            if (!this.special_groups[product.special_group]) {
              this.special_groups[product.special_group] = {
                count: 0,
                last_added_at_count: 0,
                needed_count: product.special_needed,
                free_count: product.special_free,
                max_free_count: product.special_free_max || 99,
                bulk_discount: product.special_bulk_discount,
                // EXTRA for progressive free product promos
                special_min_array: product.special_min_array,
                special_free_array: product.special_free_array,
                discount_step: 0,

                free_product: null,
                products: []
              };

              // find the free product if it is specified
              if(!!product.special_free_pid && !this.special_groups[product.special_group].free_product){
                for( const fp of this.translated_products ){
                  if( fp.id == product.special_free_pid ){
                    this.special_groups[product.special_group].free_product = {...fp}; // COPY !
                    this.special_groups[product.special_group].free_product.id = '[FREE]' + fp.id;
                    this.special_groups[product.special_group].free_product.is_hidden = true;
                    this.special_groups[product.special_group].free_product.name += ' ('+ this.dataService.translate.instant('gratis') + ')';
                    this.special_groups[product.special_group].free_product.name_NL += ' (gratis)';
                    this.special_groups[product.special_group].free_product.name_FR += ' (gratuit)';
                    this.translated_products.push(this.special_groups[product.special_group].free_product);
                    // this.special_groups[product.special_group].products.push(fp);
                    break;
                  }
                }
              }
            }
            this.special_groups[product.special_group].products.push(product);
            // keep it sorted by price
            this.special_groups[product.special_group].products.sort((a, b) => {
              return (a.base_price - b.base_price)
            });
          }
        }
        
        // now do the sorting ...
        this.translated_filters = w_filters.sort(
          (a, b) => {
            return (a.weight - b.weight)
          });
        this.ext_filters = e_filters.sort(
          (a, b) => {
            return (a.weight - b.weight)
          });
        // make one filter list
        for (let ef of this.ext_filters) this.translated_filters.push(ef);

        // show specials on start of the exhibit page (NOT)
        // if( !!this.super_orders && this.specials_count > 0) this.specials_filter = true;

        if (!!this.filter) {

          //this.reset_all_filters();
          for (let f of this.translated_filters) {
            if (f.key.toUpperCase() == this.filter.toUpperCase()) {
              f.active = true;
              this.update_filter(f);
              break;
            }
          }

        } else {
          this.update_filter();
        }
        // make sure all restrictions are set correctly from the start
        this.calculateTotal();

  }

  get_remote_products() {
    this.dataService.getAllProducts(this.allow_first_order_specials).subscribe(
      (data) => {
      this.process_productlist(
          this.dataService.process_products(
            data,
            this.allow_first_order_specials
          )
        );
      },
      (error) => {
        this.loading = false;
        console.warn(error);
        if (error.status === 403) {
          // this.dataService.show_shop = false;
        }
      },
      () => {
        this.loading = false; // done retrieving info
        if (!!this.show_details_for) {
          for (let prd of this.translated_products) {
            if (prd.id == this.show_details_for) {
              this.addItem(prd);
              this.open_popup(prd);
              break;
            }
          }
        }
      });
  }

  get_remote_data(refresh?: boolean) {
    // get the orders and then the products
    this.dataService.getMyOrders(refresh).subscribe((orders) => {

      this.allow_first_order_specials = (this.mode != 'anonymous');
      for (let order of orders) {
        this.dataService.adjust_date_object(order);
        let cert = undefined;
        for (let item of order.items) {
          cert = this.dataService.cert_from_product(item.product_details);
          if (!!cert) break;
        }
        // TODO: should have setting for this ...
        if (this.dataService.main_brand == 'AVENT'){

        } else {
          if (this.dataService.known_languages.indexOf('nl') > -1) {
            order.order_type = "ZOOM";
            if (this.dataService.sonicare_available && !cert) {
              order.order_type = "SONICARE";
            }
            this.my_order_by_type[order.order_type].push(order);
          } else {
            order.order_type = "SONICARE";
            this.my_order_by_type[order.order_type].push(order);
          }
        }
        if (!!order.sub_user && order.sub_user.email === this.dataService.subuser_info.email) {
          this.allow_first_order_specials = false;
        }

      }
      this.get_remote_products();
      this.my_orders = orders;
    }, (err) => {
      this.allow_first_order_specials = true;
      this.get_remote_products();
      console.warn(err);
    },
      () => {
        console.debug('done fetching orders for user');
      });
  }


  // @HostListener("window:scroll", [])
  //   onWindowScroll() {
  //     let stickyElement = this.document.getElementById('sticky');
  //     const products = this.document.getElementById('products');

  //     if (!!stickyElement) {
  //       window.scrollY >= this.filterOriginalOffset ? stickyElement.classList.add('fixed') :
  //                                   stickyElement.classList.remove('fixed');
  //     }
  //     if (!!products) {
  //       window.scrollY >= this.filterOriginalOffset ? products.classList.add('fixed') :
  //       products.classList.remove('fixed');
  //     }

  // }

  startBodyScroll() {
    this.body.style.overflow = 'auto';
  }

  stopBodyScroll() {
    this.body.style.overflow = 'hidden';
  }

  close_popup() {
    this.selected_product = undefined;
    this.checkout_view = false;
    this.startBodyScroll();
  }

  open_popup(prod) {
    if (prod.is_asset) return; // no need to pop this up
    this.stopBodyScroll();
    this.selected_product = prod;
    this.dataService.product_detail_event(prod);
  }

  all_filters_are_empty() {
    return !this.keywords && !this.hidden_keywords && this.active_filters.length == 0 && !this.cart_filter && !this.specials_filter && !this.loyaltyproduct_filter && !this.first_order_filter && !this.order_filter;
  }

  reset_special_filters() {
    if(!!this.my_orders){
      for (let order of this.my_orders) order.selected = false;
    }
    this.order_filter = undefined;
    this.specials_filter = false;
    this.loyaltyproduct_filter = false;
    this.cart_filter = false;
    this.first_order_filter = false;
  }

  reset_product_filters() {
    for (let filter of this.translated_filters) filter.active = false;
    this.active_filters = [];
    this.hidden_keywords = null;
  }

  reset_all_filters() {
    this.reset_special_filters();
    this.reset_product_filters();
  }

  toggle_specials() {
    if (this.specials_filter) {
      this.reset_all_filters();
      this.specials_filter = true;
    }
    this.update_filter();
  }

  toggle_loyaltyproducts() {
    if (this.loyaltyproduct_filter) {
      this.reset_all_filters();
      this.loyaltyproduct_filter = true;
    }
    this.update_filter();
  }

  toggle_first_order_specials() {
    if (this.first_order_filter) {
      this.reset_all_filters();
      this.first_order_filter = true;
    }
    this.update_filter();
  }


  toggle_order_filter(selected_order) {
    // for(let order of this.my_orders){
    //   if( order.id !== selected_order.id ){
    //     order.selected = false;
    //   }
    // }

    if (!!selected_order.selected) {
      this.reset_all_filters();
      selected_order.selected = true;
      this.order_filter = selected_order
    } else {
      this.reset_all_filters();
    }
    this.update_filter();
  }

  _is_part_of_selected_order(prod) {
    if (!this.order_filter) return false;
    for (let item of this.order_filter.items) {
      if (prod.id == item.sku) return true;
    }
    return false;
  }

  update_filter(filter?) {
    if (!!filter) {
      if (filter.active) {
        this.reset_special_filters();
        this.active_filters.push(filter);
      } else {
        let found = undefined;
        for (let f in this.active_filters) {
          if (this.active_filters[f].key == filter.key) {
            found = f;
            break;
          }
        }
        this.active_filters.splice(found, 1);
      }
    }

    // if(this.all_filters_are_empty()){
    //   this.filtered_products = this.translated_products;
    //   return
    // }

    let new_list = [];

    for (let prod of this.translated_products) {
      if(!!prod.is_hidden) continue;
      let selected = true; // need to be selected by ALL not empty filters ....
      const pr_data = JSON.stringify(prod).toLowerCase();

      if (this.cart_filter || this.specials_filter || this.first_order_filter || !!this.order_filter || this.loyaltyproduct_filter) {
        selected = (!!this.cart_filter && (prod.order_amount > 0))
          || (!!this.specials_filter && !!prod.is_special && !prod.max_points_allowed) // dont count point products as special, only if it also has special.
          || (!!this.loyaltyproduct_filter && !!prod.max_points_allowed  ==! null)
          || (!!this.first_order_filter && prod.status == 'FIRSTORDER_SPECIAL')
          || (!!this.order_filter && !!this._is_part_of_selected_order(prod));

      } else {

        for (let filter of this.active_filters) {
          if (!!filter.asset_only && !!prod.is_asset) {
            selected = prod.categorie == filter.key || prod.filter == filter.key;
            if (!selected) this.hidden_keywords = filter.key;
          } else {
            selected = prod.filters.indexOf(filter.key) > -1;
          }
          if (selected) break;
        }
      }

      if (selected && !!this.hidden_keywords) {
        let selected_by_kw = false;
        for(const kw of this.hidden_keywords.toLowerCase().split(' ')) {
          selected_by_kw = selected_by_kw || pr_data.indexOf(kw) !== -1;
        }
        if(!selected_by_kw) selected = false;
      }

      if (selected && !!this.keywords) {
        let selected_by_kw = false;
        for(const kw of this.keywords.toLowerCase().split(' ')) {
          if(!!kw && kw.length > 1) {
            selected_by_kw = selected_by_kw || pr_data.indexOf(kw) !== -1;
          }
        }
        if(!selected_by_kw) selected = false;
      }

      if (selected) {
        if (this.type == 'assets' && !!prod.is_asset) new_list.push(prod);
        if (this.type != 'assets' && !prod.is_asset) new_list.push(prod);
      }
    }
    this.filtered_products = new_list;
  }

  _adjust_product_price(product) {
    if (!!product.price_from_unit_count) {
      for (let min_count in product.price_from_unit_count) {
        let new_base = product.price_from_unit_count[min_count];
        if (!!new_base && product.order_amount >= min_count) {
          product.base_price = new_base;
        }
      }
      if (product.base_price < product.price_from_unit_count['1']) {
        product.orig_price = product.price_from_unit_count['1'];
      } else {
        product.orig_price = product.clean_orig_price;
      }
    }
  }

  // check if order amount > 0
  // check if cart gets updated accordingly
  // add the redeem point logic
  // check if it isn't going over the maximum amount
  onChangeUpdateCount(product, event) {
    product.order_amount = Math.abs(product.order_amount); // make sure we have a valid integer bigger then zero, not starting with a zero..
    try {
      product.order_amount = Math.abs(event);
    } catch(e ){

    };

    if ((product.order_amount > 0) && !isNaN(product.order_amount)) {
      if (!!product.max_units && (product.order_amount * product.unit_count) > product.max_units) {
        product.order_amount = product.max_units-1;
        setTimeout(() => this.addItem(product), 10);
      }

      this._adjust_product_price(product);
    } else {
      product.order_amount = 0;
    }
    this.calculateTotal(product.status != 'REDEEM_POINT');
    this.update_filter();
  }

  toggle_express_shipping(){
    let pr = this.dataService.express_shipping_product;
    if( !pr ) return;
    if( pr.order_amount == 0){
      this.addItem(pr);
    } else {
      this.removeItem(pr);
    }
  }

  addItem(product, event?, is_free?) {
    if (!!event) {
      event.stopPropagation();
    }
    try{ window['set_page_name']('add_product') }catch(e){};
    const is_normal = product.status != 'REDEEM_POINT';

    if(!!is_free){
      if( !product.free_count ) product.free_count = 0;
      product.free_count += 1;
      product.order_amount++;
    } else {
      product.order_amount++;
    }
    // not allowed more ...
    if (is_normal && !!product.max_units && (product.order_amount * product.unit_count) > product.max_units) {
      product.order_amount = product.max_units;
    }
    if (is_normal && product.max_units == 0 && !!product.next_order_date){
      product.order_amount = 0;
    }

    // if( product.unit_count > 0 && !!product.max_points_allowed ){
    //     this.redeem_points += product.max_points_allowed * product.unit_count;
    //     this.redeem_points = Math.min(this.redeem_points, this.dataService.user_info.loyalty_balance);
    // }
    this._adjust_product_price(product);
    this.calculateTotal(is_normal, !!is_free);
    if( is_normal && !!product.max_points_allowed ) {
      // need second calc since points may have changed
      this.calculateTotal(is_normal, !!is_free);
    }
    this.update_filter();
    const cart = this.translated_products.filter(pr => pr.order_amount > 0);
    this.dataService.product_add_event(product, 1, cart);
  }

  removeItem(product, event?) {
    if( !!event ) {
      event.stopPropagation();
    }
    // console.log('extract one of this product: ',product);
    if (product.order_amount > 0) {
      product.order_amount--;
      // if( product.unit_count > 0 && !!product.max_points_allowed ){
      //   this.redeem_points -= product.max_points_allowed * product.unit_count;
      //   this.redeem_points = Math.min(this.redeem_points, this.dataService.user_info.loyalty_balance);
      // }
      this._adjust_product_price(product);
      let is_normal = product.status != 'REDEEM_POINT';
      if( !!product.is_sticky ){
        product.is_changed = true;
      }
      this.calculateTotal(is_normal, product);
      if( is_normal && !!product.max_points_allowed ) {
        // need second calc since points may have changed
        this.calculateTotal(is_normal);
      }

      this.update_filter();

      if (this.total_products_amount == 0) {
        for (let p of this.translated_products) {
          if (p.needs_paid_product) {
            p.order_amount = 0;
          }
        }
        this.calculateTotal(is_normal, product);
        this.update_filter();
      }
      const cart = this.translated_products.filter(pr => pr.order_amount > 0);
      this.dataService.product_remove_event(product, 1, cart);
    }
  }
  _update_discount_step(group, inc){
    let new_step = group.discount_step + inc;
    if( new_step < 0 ) new_step = 0;
    if (new_step > group.special_free_array.length-1) new_step = group.special_free_array.length - 1;
    
    const new_free = parseInt(group.special_free_array[new_step]);
    const new_min = parseInt(group.special_min_array[new_step]);
    group.prev_free = 0;
    if( new_step > 0 ){
      group.prev_free = parseInt(group.special_free_array[new_step-1]);
    }
    group.free_count = new_free;
    group.needed_count = new_min + new_free;
    group.discount_step = new_step;
  }

  calculateTotal(normal_product?: boolean, removing?: any) {
    this.total_products_amount = 0;
    this.total_amount = 0;
    this.total_products = 0;
    this.total_retail_value = 0;
    this.total_discount = 0;
    this.discount_from_points = 0;
    for (let grp in this.special_groups) {
      this.special_groups[grp].count = 0;
    }
    let first_order_count = {};
    let cart_discount_prod = undefined;
    for (let product of this.translated_products) {
      if( !!product.total_discount ){
        cart_discount_prod = product;
        continue;
      }
      let count_order = product.order_amount * product.unit_count;
      if (product.status != 'REDEEM_POINT') {
        this.total_products += count_order;
      }
      // this.total_amount += count_order * product.base_price;
      if (!!product.retail_price) {
        this.total_retail_value += count_order * product.retail_price;
      }
      if (product.status == "FIRSTORDER_SPECIAL") {
        first_order_count[product.id] = count_order;
      }
      if(!!product.special_group && !!this.special_groups && !!this.special_groups[product.special_group]) {
        this.special_groups[product.special_group].count += product.order_amount;
      }
    }

    // calc grouped special discounts
    if (!!this.special_groups) {
      for (let group_name in this.special_groups) {
        let group = this.special_groups[group_name];
        if( group_name == 'STICKY' ) {
          if( this.total_products == 1){
            for( let pr of group.products ){
              if( !pr.is_changed ){
                pr.order_amount = group.needed_count || 0;
              }
            }
          }
        } else {
        // handle group bulk discounting logic
        if (group.bulk_discount) {
            // get correct discount level
            let discount = 0.0;
            for (const b in group.bulk_discount) {
              const b_int = parseInt(b);
              if (group.count >= b) discount = Math.max(discount, group.bulk_discount[b]);
            }
            for (let disc_pro of group.products) {
              disc_pro.orig_price = disc_pro.clean_orig_price;
              // disc_pro.base_price = disc_pro.clean_orig_price - Math.floor(discount * disc_pro.clean_orig_price);
              disc_pro.base_price = disc_pro.clean_orig_price - (discount * disc_pro.clean_orig_price);
              
            }
          }

          // find the breakpoints for giving  the next free product ....
          let free_products_in_group = 0;
          for(const pr of group.products){
            if(!!pr.free_count){
              free_products_in_group += pr.free_count;
            }
          }

          // if(free_products_in_group) free_products_in_group += group.free_count; // future

          let just_one_needed = (group.count + group.free_count + 1) % (group.needed_count) == 0;
          let add_free_products = (group.count + group.free_count) % (group.needed_count) == 0;
          if (!!group.free_product){
            if (!!group.special_free_array) {
              let treshold = parseInt(group.special_min_array[group.discount_step]);
              // if (!!removing && group.discount_step > 0 && group.discount_step < group.special_free_array.length-1){
              //   treshold = parseInt(group.special_min_array[group.discount_step-1]);
              // }
              just_one_needed = (group.count + 1) == treshold;
              add_free_products = group.count == treshold;
            } else {
              const treshold = group.needed_count - group.free_count;
              just_one_needed = (group.count + 1) % treshold == 0;
              add_free_products = (group.count) % treshold == 0;
            }
            if (just_one_needed && !!group.special_free_array && !!removing.special_group) {
              if (removing.special_group == group_name) {
                this._update_discount_step(group, -1);
              }
            }  
            if (just_one_needed && !!removing && !!group.free_product && group.count == (group.last_added_at_count-1)){
               if(!!removing.special_group && removing.special_group == group_name && group.free_product.order_amount > 0){
                  if( !!group.special_free_array ){
                    let new_free = 0
                    if (group.discount_step > 0){
                      new_free = parseInt(group.special_free_array[group.discount_step]);
                    }
                    group.free_product.order_amount -= group.free_product.free_count - new_free;
                    group.free_product.free_count = new_free;
                    group.last_added_at_count = new_free;
                  } else {
                    group.free_product.free_count -= group.free_count;
                    group.free_product.order_amount -= group.free_count;
                    group.last_added_at_count -= group.needed_count - group.free_count;
                    // const discount_amount = group.free_product.base_price * group.free_product.free_count;
                    // this.total_discount += discount_amount;
                    // this.total_amount -= discount_amount;
                  }
               }
             }

            if( !removing && group.free_product.free_count >= group.max_free_count){
                just_one_needed = false;
                add_free_products = false;
             }

          }

          if(group.count == 0 || group.last_added_at_count == group.count) add_free_products=false;

          if( (group.needed_count - group.free_count) > 1 ){
            // do not show the allert if we have a 1+N type promo
            for(let pr of group.products){
              pr.just_one_needed = just_one_needed;
            }
          }

          if (add_free_products && !!group.free_count && !removing) {
            // add a free product to the cart with selector
            let fpr = group.free_product;
            if ( !fpr ){// find the cheapest
              // TODO: allow to choose ??
              for(const spr of group.products){
                if(!!spr.order_amount){
                  fpr = spr;
                  break;
                }
              }
            }

            // add free_count new products
            group.last_added_at_count = group.count;
            let start_free = 0;
            if( !!group.prev_free ){
              start_free = group.prev_free;
            }
            for(let i=start_free; i< group.free_count; i++) {
              setTimeout(() => this.addItem(fpr, null, true), 200);
            }
            if( group.special_free_array ){
              this._update_discount_step(group, +1);
            }
          }
          if(!!group.free_product && !!group.free_product.free_count){
            const discount_amount = group.free_product.base_price * group.free_product.free_count;
            this.total_discount += discount_amount ;
            this.total_amount -= discount_amount;
          }
          if (!group.free_product && group.free_count && group.count >= group.needed_count && !!group.free_count) {

            let free_count = Math.floor(group.count / group.needed_count) * group.free_count;
            if (free_count > 0) {
              // now we know the cheapest product and can apply the discounts
              let need_to_discount = free_count;
              for (let pindex = 0; pindex < group.products.length; pindex++) {
                if (need_to_discount > 0) {
                  let can_discount = Math.min(group.products[pindex].order_amount, need_to_discount);
                  let discount_amount = can_discount * group.products[pindex].base_price;
                  group.products[pindex].free_count = can_discount;

                  this.total_discount += discount_amount;
                  this.total_amount -= discount_amount;
                  need_to_discount -= can_discount;
                } else group.products[pindex].free_count = 0;
              }
            }

          } else {
            for (let pindex in group.products) group.products[pindex].free_count = 0;
          }
        }
      }
    }

    if (this.dataService.max_first_order_specials > 0) {
      for (let product of this.translated_products) {
        if (product.status == "FIRSTORDER_SPECIAL") {
          let new_max = this.dataService.max_first_order_specials;
          for (let other_pid in first_order_count) {
            if (product.id != other_pid) new_max -= first_order_count[other_pid];
          }
          product.max_units = new_max;
          product.tag = `Max. ${new_max}`;
        }
      }
    }
    // total discount now only knows about free items, need to calc all (bulk)discounted items in an second pass
    this.max_redeem_points = 0;
    for (let product of this.translated_products) {
      if( !!product.total_discount ) continue;
      let count_order = product.order_amount * product.unit_count;
      if (count_order > 0 && !!product.orig_price) {
        this.total_amount += count_order * product.base_price;
        this.total_discount += count_order * (product.orig_price - product.base_price);
      }
      if (!!product.max_points_allowed) {
        this.max_redeem_points += count_order * product.max_points_allowed;
      }
    }
    if (!!this.dataService.user_info) {
      if (this.max_redeem_points > this.dataService.user_info.loyalty_balance) {
        this.max_redeem_points = this.dataService.user_info.loyalty_balance;
      }

      let redeem_point_prod = this.dataService.redeem_point_product;
      if (!!redeem_point_prod) {


        redeem_point_prod.max_units = this.max_redeem_points;
        if(this.max_redeem_points < redeem_point_prod.unit_count) {
          redeem_point_prod.unit_count = 1;
        }

        const max_redeem_prod_count = Math.trunc(this.max_redeem_points / redeem_point_prod.unit_count);

        if (redeem_point_prod.order_amount > max_redeem_prod_count || normal_product) {
          redeem_point_prod.order_amount = max_redeem_prod_count;
        }

        // this.total_discount = this.total_retail_value - this.total_amount;

        // add the discount for points...
        const redeem_discount = -1 * redeem_point_prod.order_amount * redeem_point_prod.unit_count * redeem_point_prod.base_price;
        // this.total_discount += redeem_discount;
        this.discount_from_points += redeem_discount;
      }
    }
    // CART DISCOUNT LOGIC
    if( !!cart_discount_prod ){
      cart_discount_prod.base_price = -1 * cart_discount_prod.total_discount * this.total_amount;
      cart_discount_prod.orig_price = cart_discount_prod.base_price;
      cart_discount_prod.order_amount = 1;
      this.total_discount -= cart_discount_prod.base_price;
      this.total_amount += cart_discount_prod.base_price;
    } 
    // FREE SHIPPING LOGIC
    let min_amount_needed = this.dataService.pivot_point - this.discount_from_points;
    if(!!this.dataService.express_shipping_product && this.dataService.express_shipping_product.order_amount > 0){
      min_amount_needed += this.dataService.express_shipping_product.base_price;
    }
    if (this.total_amount < min_amount_needed) {
      this.order_shipping_cost = this.dataService.shipping_costs ;
    } else {
      this.order_shipping_cost = 0;
    }
    if( this.total_amount < 1){
      // free orders also shop for free
      this.order_shipping_cost = 0;
    }
    this.total_products_amount = this.total_amount;
    this.total_amount += this.order_shipping_cost;
    // max discount logic
    if( !!this.dataService.max_discount && this.dataService.max_discount > 0){
      const allowed_disc = this.dataService.max_discount - this.total_discount; // per prod
      for (let product of this.translated_products) {
        if( !!product.orig_price  && product.unit_count * (product.orig_price - product.base_price) > allowed_disc ){
          product.max_units = product.order_amount * product.unit_count;
        } else {
          product.max_units = product.__max_units; // orig value
        }
      }
    }
    if (this.mode == 'anonymous') this.collect_order();
  }

  // NOT USED !!
  // calculateShippingCosts() {
  //   if (!this.order_shipping_cost){
  //     return 'strike-through';
  //   } else {
  //     return '';
  //   }
  // }

  resetProductCounters() {
    for (let product of this.translated_products) {
      product.order_amount = 0;
      product.free_count = 0;
    }
    for(let gr of this.special_groups){
      if(!!gr.free_product){
        gr.count = 0;
        gr.last_added_at_count = 0;
        if(!!gr.special_free_array){
          this._update_discount_step(gr, -99);
        }
        gr.products = [];      
      }
    }
    this.calculateTotal(true);
    this.update_filter();
  }

  start_edit_invoice() {
    this.prev_address = JSON.stringify(this.dataService.user_info);
    if (!!this.dataService.user_info.postalcode && !this.dataService.user_info.invoice_postalcode) {
      this.dataService.user_info.invoice_postalcode = this.dataService.user_info.postalcode;
    }
    if (!!this.dataService.user_info.city && !this.dataService.user_info.city) {
      this.dataService.user_info.invoice_city = this.dataService.user_info.city.replace('CITY', '');
    }
    this.edit_invoice = true;
  }

  reset_edit_invoice() {
    this.dataService.user_info = JSON.parse(this.prev_address);
    this.edit_invoice = false;
  }

  check_invoice() {
    this.invoice_complete = !!this.dataService.user_info.invoice_company &&
      !!this.dataService.user_info.invoice_address &&
      !!this.dataService.user_info.invoice_postalcode &&
      !!this.dataService.user_info.invoice_city;

    // return this.invoice_complete;
  }

  change_invoice_address() {
    this.saving_invoice = true;
    // handle invalid VAT nummers (to short !)
    if (!!this.dataService.user_info.invoice_vatnumber && this.dataService.user_info.invoice_vatnumber.length < 10) {
      this.dataService.user_info.invoice_vatnumber = "";
      this.dataService.user_info.invoice_vatpercentage = "";
    }

    let new_user_info = JSON.stringify(this.dataService.user_info);
    if (new_user_info === this.prev_address) {// nothing was changed
      this.edit_invoice = false;
      this.saving_invoice = false;
    }
    if (!!this.super_orders) {
      // this is actually also the post address
      this.dataService.user_info.company = this.dataService.user_info.invoice_company;
      this.dataService.user_info.address = this.dataService.user_info.invoice_address;
      this.dataService.user_info.postalcode = this.dataService.user_info.invoice_postalcode;
      this.dataService.user_info.city = this.dataService.user_info.invoice_city;
      this.saving_invoice = false;
      this.edit_invoice = false;
    } else {
      this.dataService.updateUserInfo(this.dataService.user_info).subscribe((userinfo) => {
        this.dataService.user_info = userinfo;
        this.prev_address = JSON.stringify(this.dataService.user_info);
        this.edit_invoice = false;
        this.saving_invoice = false;
      })
    }

  }

  collect_order() {
    this.redeem_points = 0;
    this.dataService.products_to_order = { items: [] };
    // loop through the ordered_products
    for (let product of this.translated_products) {
      if (product.order_amount > 0) {
        let add_product = {
          sku: product.id,
          count: product.order_amount
        };
        this.dataService.products_to_order.items.push(add_product);
        if (product.status == 'REDEEM_POINT') {
          this.redeem_points = product.order_amount * product.unit_count;
        }
      }
    }
    // NOTE the server will handle free shipping logic.
    const shipping_costs = { sku: this.dataService.shipping_sku, count: 1 };
    this.dataService.products_to_order.items.push(shipping_costs);
    if( !!this.show_optin && !!this.dataService.subuser_info.optin_promos ){
      this.dataService.order_optin = true;
    }
  }

  finishOrder() {
    console.log('let\'s wrap up this order!');
    this.ordering = true;
    // this.dataService.presentMessage('Uw bestelling wordt verwerkt, even geduld A.U.B.','');

    this.collect_order();

    let total_amount = this.total_amount;

    let new_user_email = null;

    if (!!this.super_orders) {
      // this is actually also the post address
      this.dataService.user_info.invoice_company = null;
      this.dataService.user_info.invoice_address = null;
      this.dataService.user_info.invoice_postalcode = null;
      this.dataService.user_info.invoice_city = null;

      new_user_email = this.dataService.generate_fake_email(this.dataService.new_user_firstname, this.dataService.new_user_lastname, this.dataService.user_info.id);

      if (!!this.dataService.new_user_email) {
        new_user_email = this.dataService.new_user_email;
        if (!this.dataService.send_order_email) {
          new_user_email = this.dataService.cripple_email(new_user_email);
        }
      }
    }
    try{ window['set_page_name']('confirm_order') }catch(e){};
    const cart = this.translated_products.filter(pr => pr.order_amount > 0);

    this.dataService.postOrder(new_user_email).subscribe(
      (result) => {
        console.log(result);
        this.dataService.confirm_order_event(cart, {
          id: result.id, // ??
          shipping: this.order_shipping_cost,
          revenue: (1.0 + this.dataService.shop_vat_rate) * this.total_amount,
          tax: this.dataService.shop_vat_rate * this.total_amount,
          discount: this.total_discount
        })

        this.dataService.presentMessage(
          'Uw bestelling is succesvol geplaatst!', 'success', 0);

        if (this.redeem_points > 0 && !!this.dataService.user_info && !!this.dataService.user_info.loyalty_balance) {
          // TODO: verfy the redeem points as returned from the server !
          this.dataService.user_info.loyalty_balance -= this.redeem_points;
          // this.dataService.saveUserInfo(this.dataService)
          this.redeem_points = 0;
        }

        this.reset_all_filters();

        // reset first order logic
        if (this.dataService.main_brand == 'AVENT' || this.allow_first_order_specials) {
          this.allow_first_order_specials = false;
          this.first_order_specials_count = 0;
          this.resetProductCounters();
          this.get_remote_data(true);
        } else {
          this.resetProductCounters();
        }
        this.confirm_order = false;
        this.ordering = false;
        this.close_popup();
        if( this.dataService.main_brand !== 'AVENT' ){
          try{  window['hj']('trigger', 'show_after_checkout_poll_' + this.dataService.current_language) } catch (e) {};
        }

      },
      (err) => {
        console.log(err);
        this.confirm_order = false;
        this.ordering = false;
        this.dataService.presentMessage(
          'Er is iets fout gegaan tijdens het versturen van uw bestelling. Uw sessie is verlopen. Log uit en weer in en probeer het nogmaals. Neem contact op met de klantenservice als dit probleem zich voor blijft doen.',
          'error', 0);
      },
      () => {
        console.log('done posting stuff');
        this.ordering = false;
      }
    )
  }

  checkout() {
    if (!this.dataService.user_info) return;

    if (this.total_products && (this.super_orders || this.mode != 'anonymous')) {
      this.stopBodyScroll();
      // this.reset_all_filters();
      // this.cart_filter = true;
      // this.update_filter();
      this.checkout_view = true;

      try{ window['set_page_name']('checkout') }catch(e){};
      const cart = this.translated_products.filter(pr => pr.order_amount > 0);
      this.dataService.show_cart_event(cart);
      let total_amount = this.total_amount;
    }
  }



  forgetUser() {
    this.dataService.forgetUserInfo();
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/productlist/productlist.component.ts